import axios from 'axios';
import Links from '../constants/Links'; 


/**
 * This is the Illness API hook, for handling Illness (C) 2021-2023
 */

const Illness = {
    /**
     * @description Creates an illness
     * @param data An object containing 
     * @returns {Promise<object>}
     */
    create: async (data) => {
        return axios.post(Links.illness.create, data)
    },

    /**
     * @description Updates an existing illness
     * @param id ID of the illness to update
     * @param data An object containing 
     * @returns {Promise<object>}
     */
     update: async (id, data) => {
        return axios.put(Links.illness.update + '/' + id, data)
    },

    /**
     * @description Deletes an illness
     * @param id ID of the illness to delete
     * @returns {Promise<object>}
     */
    delete: async (id) => {
        return axios.delete(Links.illness.delete + '/' + id)
    },

    /**
     * @description Gets all illnesses(paginated)
     * @param page the page to get
     * @param size the size to get
     * @returns {Promise<any[]>}
     */
    all: async (page, size) => {
        return axios.get(Links.illness.all + '?page=' + page + '&size=' + size)
    }
}

export default Illness